export default __webpack_public_path__ + "static/media/fullscreen-icon.cbd8c3b0.svg";